import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { loadConfig, loadConfigError, loadConfigSuccess } from './config.actions';
import { LoadConfigService } from 'src/app/services/load-config.service';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { Action } from '@angular-devkit/schematics';
import { selectConfig } from './config.selectors';
import { MediaLoaderService } from 'src/app/services/media-loader.service';
import { InstructionService } from 'src/app/services/instruction.service';
import { StudyNavigationService } from 'src/app/services/study-navigation.service';
import { enablePage } from '../app-meta/app-meta.actions';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { ConfigApiService } from 'src/app/services/config-api.service';

@Injectable()
export class ConfigEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private loadConfigService: LoadConfigService,
    private mediaLoaderService: MediaLoaderService,
    private instructionService: InstructionService,
    private studyNavigationService: StudyNavigationService,
    private configApiService: ConfigApiService
  ) { }


  test$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadConfig),
      withLatestFrom(this.store.select(selectConfig)),
      take(1),
      mergeMap(([, configStatus]) =>
        from(this.orchestrateConfigDistribution(configStatus)).pipe(
          switchMap(() => {
            return of(
              loadConfigSuccess()
            )
          }
          ),
          catchError((err) => {
            console.error(err);
            this.store.dispatch(enablePage({
              disablePage: true,
              stopLoadingSpinner: true,
              noConfigData: true
            }))
            return of(loadConfigError({ error: err.message }));
          }
          )
        )
      )
    ));

  private async orchestrateConfigDistribution(configStatus) {
    this.loadConfigService.setUserID(this.configApiService.getParams().user);
    // console.log('config in effects: ', configStatus.config['client_config']);
    await this.loadConfigService.setClientConfig(configStatus.config['client_config']);
    await this.loadConfigService.setConfig(configStatus.config['config']);

    await this.mediaLoaderService.setMediaFiles(configStatus.config['media']);

    await this.instructionService.setInstructions(configStatus.config['instructions']);
    await this.instructionService.setTranslations(configStatus.config['translations']);

    // Tobi: does not work with mock-up data - try with real config
    await this.mediaLoaderService.initLookupTable();

    // Tobi: does not work with mock-up data - try with real config
    await this.studyNavigationService.init();

    this.store.dispatch(enablePage({
      disablePage: false,
      stopLoadingSpinner: false,
      noConfigData: false
    }))
  }
}